import React from 'react';

import { demoPrivacyInputBlurStyles } from 'src/constants/demoPrivacyMode';

import { useDemoPrivacyBlurred } from './useDemoPrivacyBlurred';

export const useDemoPrivacyInputSlotProps = () => {
  const isBlurred = useDemoPrivacyBlurred();

  return React.useMemo(
    () => (isBlurred ? { input: { sx: demoPrivacyInputBlurStyles } } : undefined),
    [isBlurred],
  );
};
